<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
  gotoCollection: (id: string) => void
}>()

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div v-if="module.resourceList.records[0]" class="mt-12px rr-first" @click="gotoBook(module.resourceList.records[0].id, module.resourceList.records[0].firstChapter?.id)">
      <BizBookCover
        :id="uuid()"
        :src="module.resourceList.records[0].contentCoverUrl || ''"
        :extra="{
          module_name: module.showName,
          module_id: module.id,
          module_type: module.columnType,
          author: module.resourceList.records[0]?.authorInfo?.author,
          ...module.resourceList.records[0],
        }"
        class="rr-first-cover rounded-10px"
      />
      <div class="rr-first-content">
        <p class="text-15px font-700 lh-20px text-n-text-1 line-clamp-2">
          {{ module.resourceList.records[0].contentName }}
        </p>
        <BizShowTags
          v-if="module.resourceList.records[0].tagList && module.resourceList.records[0].tagList.length"
          :tags="module.resourceList.records[0].tagList"
          class="mt-8px"
        />
        <p class="rr-home-book-intro mt-8px text-12px lh-17px text-n-text-3 line-clamp-3">
          {{ module.resourceList.records[0].introduce }}
        </p>
      </div>
    </div>

    <div class="mt-12px grid grid-cols-3 gap-x-10px gap-y-15px">
      <div v-for="item in module.resourceList.records.slice(1, 4)" :key="item.id" @click="gotoBook(item.id, item.firstChapter?.id)">
        <BizBookCover
          :id="uuid()"
          :src="item.contentCoverUrl || ''"
          :extra="{
            module_name: module.showName,
            module_id: module.id,
            module_type: module.columnType,
            author: item.authorInfo.author,
            ...item,
          }"
          class="rounded-10px"
        />
        <p class="mt-7px text-12px font-medium lh-17px text-n-text-1 line-clamp-2">
          {{ item.contentName }}
        </p>
      </div>
    </div>
  </ModuleCard>
</template>

<style scoped>
.rr-first {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}

.rr-first-cover {
  width: calc((100% - 20px) / 3);
  flex-shrink: 0;
}

.rr-first-content {
  flex: 1;
  min-width: 0;
}
</style>
